import * as actionTypes from "../actionTypes";

const initialState = {
  is_error: false,
  security_questions: [],
};

const accountReducer = (state = initialState, action) => {
  const { type, payload = {} } = action;

  switch (type) {
    case actionTypes.GET_SECERUITY_QUE_FAILED:
    case actionTypes.SAVE_PROFILE_DETAILS_FAILED:
    case actionTypes.CHANGE_PASSWORD_DETAILS_FAILED:
      return {
        ...state,
        is_error: true,
      };
    case actionTypes.GET_SECERUITY_QUE_SUCCEEDED:
    case actionTypes.SAVE_PROFILE_DETAILS_SUCCEEDED:
      return {
        ...state,
        ...payload,
        is_error: false,
      };
    default:
      return state;
  }
};
export default accountReducer;
